var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Actions, Effect } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import { LOGOUT, LOGOUT_SUCCESS, LogoutSuccessAction } from './auth.actions';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import { ConfigService } from '../../config/config.service';
import { redirectToAuthServer } from '../../../../old-crazy-web-frontend/src/app/auth/auth.service';
var AuthEffects = /** @class */ (function () {
    function AuthEffects(actions$, configService) {
        var _this = this;
        this.actions$ = actions$;
        this.configService = configService;
        this.logout$ = this.actions$.ofType(LOGOUT).map(function () { return new LogoutSuccessAction(); });
        this.logoutSuccess$ = this.actions$.ofType(LOGOUT_SUCCESS).do(function () {
            var AUTHENTICATION_SERVER = _this.configService.getValue('AUTHENTICATION_SERVER');
            window.location.href = redirectToAuthServer(AUTHENTICATION_SERVER, '/logout');
        });
    }
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], AuthEffects.prototype, "logout$", void 0);
    __decorate([
        Effect({ dispatch: false }),
        __metadata("design:type", Observable)
    ], AuthEffects.prototype, "logoutSuccess$", void 0);
    return AuthEffects;
}());
export { AuthEffects };
